module.exports = __webpack_public_path__ + "static/media/3.IPhone_3Gs.6ede642e.png";